import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { AuthenticationService } from '../authentication.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  providers: [MessageService],
})
export class ResetPasswordComponent implements OnInit {
  resetPasswordForm!: FormGroup;
  currentUser: any;
  fieldPasswordType: boolean;
  fieldConfirmPasswordType: boolean;
  fieldTempPasswordType: boolean;
  confirmMessage: string;
  confirmMessageSummary: string;

  constructor(
    private formBuilder: FormBuilder,
    private authenticationService: AuthenticationService,
    private router: Router,
    private messageService: MessageService,
    private translate: TranslateService
  ) {
    this.createResetForm();
  }

  ngOnInit(): void {}
  /**
   * Reset password submission
   */
  submit() {
    const currentUserValue = this.authenticationService.currentUserValue;
    if (currentUserValue) {
      this.currentUser = this.authenticationService.currentUser;

      //this.resetPasswordForm.value=
      this.authenticationService.resetPassword(this.resetPasswordForm.value, this.currentUser).subscribe(
        (res: any) => {
          this.confirmMessage = this.translate.instant('Change-Password-Success');
          this.confirmMessageSummary = this.translate.instant('Please-Login-ChangePWD-Summary');
          this.messageService.add({
            key: 'c',
            sticky: true,
            severity: 'success',
            summary: this.confirmMessage,
            detail: this.confirmMessageSummary,
          });
        },
        (err) => {
          if (err.status === 400) {
            this.messageService.add({
              key: 'logout',
              severity: 'error',
              summary: 'Error',
              detail: err.error.message,
            });
          } else {
            this.messageService.add({
              key: 'logout',
              severity: 'error',
              summary: 'Error',
              detail: err.error.message,
            });
          }
        }
      );
    } else {
      this.messageService.add({
        key: 'logout',
        severity: 'error',
        summary: this.translate.instant('Error'),
        detail: this.translate.instant('WrongWindow'),
      });
    }
  }
  /**
   * Onclose confirm box
   */
  onReject() {
    this.messageService.clear('c');
    this.authenticationService.logout().subscribe();
    //   setTimeout(() => {
    this.messageService.add({
      key: 'logout',
      severity: 'success',
      summary: this.translate.instant('Success'),
      detail: this.translate.instant('LogOut-Success'),
    });
    this.router.navigate(['/home']);
  }
  /**
   * Creating Reset password form
   */
  private createResetForm() {
    this.resetPasswordForm = this.formBuilder.group({
      tempPassword: new FormControl(null, Validators.required),
      password: new FormControl(null, Validators.required),
      confirmPassword: new FormControl(null, Validators.required),
    });
  }
  /**
   * show hide passwords when clicking eye icon
   */
  togglePasswordType() {
    this.fieldPasswordType = !this.fieldPasswordType;
  }
  toggleConfirmPasswordType() {
    this.fieldConfirmPasswordType = !this.fieldConfirmPasswordType;
  }
  toggleTempPasswordType() {
    this.fieldTempPasswordType = !this.fieldTempPasswordType;
  }
}
